export const environment = {
  apiURL: 'https://demo9.xeniosblockchaingroup.com',
  appVersion: require('../../package.json').version,
  background: 'afs-background.png',
  logo: 'afs-logo.png',
  name: 'Afs',
  production: false,
  sentryDSN: '',
  sentryEnvironment: '',
};
